import React, { useEffect, useCallback, useState } from 'react';
import { Button, Form, Spinner } from "react-bootstrap";
import { useLazyQuery, useMutation } from '@apollo/client';
import { COLOR_WHITE, LINEAR_GRADIENT_BG, STOCK_OPTION_ITEM_SALE_TAG_KEYS, STOCK_OPTION_TAG_KEYS } from '../../../../const';
import { ReactIcons } from '../../../../icons';
import { UPDATE_STOCK_OPTION, UPDATE_MANY_STOCK_OPTION_ITEM } from '../../../../apollo/stockOption/mutation';
import { CREATE_STOCK_OPTION } from '../../../../apollo/stockOption/mutation';
import {
    Table,
    Dropdown
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTrash,
    faPlus,
} from "@fortawesome/free-solid-svg-icons";
import no_product from "../../../../images/no_product.png";
import { toast } from "react-toastify";
import { COLOR_APP, imageRender} from "../../../../const/index";
import _ from "lodash";
import { GET_STOCKS_OPTION_ITEMS } from "../../../../apollo/stockOption/query"; //TODO
import { GET_STOCKS } from "../../../../apollo/stockOption/query"; //TODO
import "./AddStockOption.css";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import PaginationsV2 from "../../../../components/PaginationsV2";
import { MSG_CREATE_SUCCESS, MSG_INCOMPLETE_DATA, MSG_INTERNAL_ERROR, MSG_LOADING, MSG_SUCCESS } from '../../../../const/msg';
import { convertCurrency } from '../../../../helper';

const FormStockOption = ({ data, setCancel, setClickMode, clickMode }) => {
    const [name, setName] = useState(data?.name ?? "");
    const [tag, setTag] = useState(data?.tag ?? "");
    const [saleTag, setSaleTag] = useState(data?.saleTag ?? "");
    const [isStatus, setIsStatus] = useState(data?.status ?? false);

    // apollo client hooks
    const [createStockOption, { loading: loadingCreateStockOption }] = useMutation(CREATE_STOCK_OPTION);
    const [updateStockOption, { loading: loadingUpdateStockOption }] = useMutation(UPDATE_STOCK_OPTION);
    const [updateManyStockOptionItems, { loading: loadingUpdateManyStockOptionItems }] = useMutation(UPDATE_MANY_STOCK_OPTION_ITEM);

    const handleCurrency = (currency) => {
        switch (currency) {
            case "LAK":
            case "ກີບ":
                return "LAK";
            case "BAHT":
            case "ບາດ":
                return "BAHT";
            case "USD":
            case "ໂດລາ":
                return "USD";
            default:
                return "LAK"
        }
    } 
    // create promotion
    const handleCreate = async () => {
        if (loadingCreateStockOption) {
            return toast.warning(MSG_LOADING);
        };
        if (_.isEmpty(stockOptionItems) || _.isEmpty(name) || _.isEmpty(tag) || _.isEmpty(saleTag)) {
            console.log("stockOptionItems", stockOptionItems.length);
            console.log("name", name);
            console.log("tag", tag);
            console.log("saleTag", saleTag);
            return toast.error(MSG_INCOMPLETE_DATA);
        };
        try {
            const dataStockOptionItems = stockOptionItems.map ((i) => {
                return {
                stock: i?.stock?.id,
                originPrice: i?.originPrice ?? 0,
                price: i?.price ?? 0,
                amount: i?.amount ?? 0,
                amountSale: 0,
                amountAll: i?.amountAll ?? 0,
                volume: i?.volume ?? 0,
                volumeSale: 0,
                volumeAll: i?.volumeAll ?? 0,
                currency: i?.currency ?? "LAK",
                saleTag: saleTag
            }})
            const dataStockOption = {
                tag: tag,
                name: name,
            }
            const res = await createStockOption({
                variables: {
                    dataStockOption: dataStockOption, dataStockOptionItems: dataStockOptionItems
                }
            });
            const response = JSON.parse(res?.data?.createStockOption); //({status: true, stockOption: createStockOption, stockOptionItem: createStockOptionItems});
            const {status, msg} = response;
            if (status) {
                toast.success(MSG_CREATE_SUCCESS);
                return setClickMode("view");
            } else {
                return toast.error(msg);
            }
        } catch (error) {
            console.log("Error in handleCreate: ",error);
            return toast.error(MSG_INTERNAL_ERROR);
        }
    };

    // update promotion
    const handleUpdateStockOption = async () => {
        if (loadingUpdateStockOption) {
            return toast.warning(MSG_LOADING);
        };
        if (_.isEmpty(name) || _.isEmpty(tag)) {
            return toast.error(MSG_INCOMPLETE_DATA);
        };
        try {
            const updateDataStockOption = {
                tag: tag,
                name: name,
                status: isStatus,
                saleTag: saleTag
            }
            const where = {
                tag: tag,
                stockOption: data?._id
            }
            console.log("handleUpdateStockOption....");
            const res = await updateStockOption({
                variables: {
                    data: updateDataStockOption, where
                }
            });
            const response = JSON.parse(res?.data?.updateStockOption); //({status: true, stockOption: createStockOption, stockOptionItem: createStockOptionItems});
    
            const {status, msg} = response;
            if (status) {
                toast.success(MSG_CREATE_SUCCESS);
                return setClickMode("view");
            } else {
                return toast.error(msg);
            }
        } catch (error) {
            console.log("Error in handleCreate: ",error);
            return toast.error(MSG_INTERNAL_ERROR);
        }
    };

    const handleUpdateManyStockOptionItems = async () => {
        console.log("handleUpdateManyStockOptionItems...");
        if (loadingUpdateManyStockOptionItems) {
            return toast.warning(MSG_LOADING);
        };
        if (_.isEmpty(stockOptionItems)|| _.isEmpty(saleTag)) {
            console.log("saleTag", saleTag);
            console.log("postStock", stockOptionItems);
            return toast.error(MSG_INCOMPLETE_DATA);
        };
        try {
            const dataStockOptionItems = [];
            stockOptionItems.forEach((i) => {
                dataStockOptionItems.push({
                    _id: i?._id,
                    stock: i?.stock?.id ?? i?.stock?._id,
                    originPrice: i?.originPrice ?? 0,
                    price: i?.price ?? 0,
                    amount: i?.amount ?? 0,
                    amountSale: i?.amountSale ??0,
                    amountAll: i?.amountAll ?? 0,
                    volume: i?.volume ?? 0,
                    volumeSale: i?.volumeSale ?? 0,
                    volumeAll: i?.volumeAll ?? 0,
                    currency: i?.currency ?? "LAK",
                    saleTag: saleTag
                })
            });
            const res = await updateManyStockOptionItems({
                variables: {
                    data: dataStockOptionItems,
                    where: {stockOption: data?._id}
                }
            });
            const response = JSON.parse(res?.data?.updateManyStockOptionItems); //({status: true, stockOption: createStockOption, stockOptionItem: createStockOptionItems});
            const {status, msg} = response;
            if (status) {
                // await getUserStock();
                setClickMode("view");
                return toast.success(MSG_CREATE_SUCCESS);
            } else {
                return toast.error(msg);
            }
        } catch (error) {
            console.log("Error in handleUpdateManyStockOptionItems: ",error);
            return toast.error(MSG_INTERNAL_ERROR);
        }
    };

    const [stockList, setStockList] = useState([]);
    console.log("stockList", stockList);
    const [stockTotal, setStockTotal] = useState();
    const [stockOptionItems, setStockOptionItems] = useState([]);
    const [arrSameCode, setArrSameCode] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [isRemoveAll, setIsRemoveAll] = useState(false);
    const [dataFromSelect, setDataFromSelect] = useState([]);

    const [getUserStocks, { loading: userStockLoading, data: userStockData }] =
        useLazyQuery(GET_STOCKS, { fetchPolicy: "cache-and-network" });
    const [getStockOptionItems, { loading: loadingStockOptionItems }] = useLazyQuery(
        GET_STOCKS_OPTION_ITEMS, { fetchPolicy: "cache-and-network" }
    );

    // add pagination
    const [perPageLimit, setPerPageLimit] = useState(150);
    const [page, setPage] = useState(0);
    const pageAll = stockTotal > 0 ? Math.ceil(stockTotal / perPageLimit) : 1;
    const handleChangePage = useCallback((newPage) => {
        setPage(newPage);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        const timeout = setTimeout(() => {
            getUserStock(signal);
        })
        return () => {
            clearTimeout(timeout);
            controller.abort();
        }
    }, [page, perPageLimit]);

    useEffect(() => {
        const controller = new AbortController();
        if (clickMode === "edit") {
            const signal = controller.signal;
            if (!signal.aborted) {
                handleStockOptionItems(data?._id, signal);
            }
        }
        return  () => {
            controller.abort();
        }
    }, [clickMode]);

    useEffect(() => {
        if (userStockData?.stocks) {
            setStockTotal(userStockData?.stocks?.total);

            // Filter stocks with non-empty cfMessage
            const _newStockList = userStockData?.stocks?.data.filter(
                (data) => data?.cfMessage && !_.isEmpty(data?.cfMessage)
            );
            console.log("_newStockList: ", _newStockList);
            setStockList(userStockData?.stocks?.data);
        }
    }, [userStockData]);

    const handleStockOptionItems = async (stockOptionId, signal) => {
        try {
            if (loadingStockOptionItems) {
                return toast.warning(MSG_LOADING);
            }
            // console.log("stockOptionId", stockOptionId)
            const response = await getStockOptionItems({
                variables: {
                    where: {
                        stockOption: stockOptionId,
                    }
                },
                context: {fetchOptions: {signal}}
            });
            // const _response = JSON.parse(response?.data?.getStockOptionItems);
            const {status, stockOptionItem, total, msg} = await JSON.parse(response?.data?.getStockOptionItems);
            console.log({status, stockOptionItem, total, msg});
            if (status) {
                // setOptionList(stockOptionItem || []);
                // setTotal(total || 0);
                setSaleTag(stockOptionItem[0]?.saleTag ?? '');
                let validateStockOption = stockOptionItem.map((s) => {
                    return {
                        ...s,
                        validateAmount: s?.amount,
                        validateVolume: s?.volume,
                    };
                });
                setStockOptionItems(validateStockOption);
                return toast.success(MSG_SUCCESS);
            } else {
                return toast.error(msg);
            }
        } catch (error) {
            console.log("Error in handleStockOptionItems", error);
            toast.error(MSG_INTERNAL_ERROR);
        }
    };

    const getUserStock = async (signal) => {
        try {
            let SHOP_ID = await JSON.parse(localStorage.getItem('SHOP_DATA')).id;
            if (!SHOP_ID) return toast.error(MSG_INTERNAL_ERROR);

            await getUserStocks({
                variables: {
                where: {
                    isDeleted: false,
                    shop: SHOP_ID,
                    amount: 1
                },
                orderBy: "createdAt_DESC",
                limit: perPageLimit,
                skip: page * perPageLimit,
                },
                context: { fetchOptions: { signal } }, // Pass the abort signal
            });
        } catch (error) {
            console.log("Error retrieving posts", error);
        }
    };

    // TODO Add
    const addStockOptionItem = (stock) => {
        const currency = handleCurrency(stock?.currency);
        let _newStock = {
            stock,
            price: stock?.price ?? 0,
            originPrice: stock?.originPrice ?? 0,
            amount: stock.amount ?? 0,
            amountAll: stock.amount ?? 0,
            validateAmount: 0,
            volume: stock?.volume ?? 0,
            volumeAll: stock?.volume ?? 0,
            validateVolume: 0,
            name: stock?.name ?? "",
            currency,
            status: true
        };

        // let _stockOptionItems = [...stockOptionItems];
        if (checkStockIsAdded(stock)) {
            return toast.error("ມີຢູ່ໃນລາຍການໄລຟແລ້ວບໍ່ສາມາດເພີ່ມຕື່ມໄດ້");
        }

        // _stockOptionItems.push(_newPostStock);
        setStockOptionItems([_newStock, ...stockOptionItems]);
        return;
    };

    // TODO Add All
    const onAddAllStockOptionItems = async (e) => {
        if (dataFromSelect.length > 0) {
            const _newStock = dataFromSelect.map((stock) => {
                const currency = handleCurrency(stock?.currency ?? stock?.stock?.currency);
                return {
                    ...stock,
                    price: stock?.price ?? 0,
                    originPrice: stock?.originPrice ?? 0,
                    amount: stock.amount ?? 0,
                    amountAll: stock.amount ?? 0,
                    validateAmount: 0,
                    volume: stock?.volume ?? 0,
                    volumeAll: stock?.volume ?? 0,
                    validateVolume: 0,
                    name: stock?.name ?? "",
                    currency,
                    status: true
            }});
            let newItems = [..._newStock, ...stockOptionItems];
            setStockOptionItems(newItems);
            setIsSelectAll(false);
            setDataFromSelect([]);
        }
    };

    const checkStockIsAdded = (stock) => {
        let _stockOptionItems = [...stockOptionItems];
        let isDuplicated = false;
        _stockOptionItems.map((lStock, index) => {
            if (lStock?.stock?._id == stock?.id || lStock?.stock?.id == stock?.id) isDuplicated = true;
        });
        return isDuplicated;
    };

    const removeStockFromCart = async (stock) => {
        let _stockOptionItems = [...stockOptionItems];
        let _removeLiveStock = _.remove(_stockOptionItems, stock);

        if (_removeLiveStock[0].id) {
            let _stockList = [...stockList];
            _stockList = _stockList.map((stock) => {
                if (_removeLiveStock[0]?.stock?.id == stock.id) {
                return {
                    ...stock,
                    amount: _removeLiveStock[0]?.amount + stock?.amount,
                };
                } else return stock;
            });
            setStockList(_stockList);
        }

        setStockOptionItems(_stockOptionItems);
    };

    const changeAmountOnCart = (stock, index, e) => {
        let _stockOption = [...stockOptionItems];
        // const validate = parseInt(_stockOption[index].validateAmount) || 0;
        const amountStock = parseInt(_stockOption[index].stock.amount || 0);
        const enterAmount = parseInt(e.target.value || 0);
        const amountSale = parseInt(_stockOption[index].amountSale || 0);
        const amountAll = parseInt(_stockOption[index].amountAll || 0);
        const amountOld = parseInt(_stockOption[index].amount || 0);

        // if ( (validate + amountStock) < enterAmount ) {
        if (amountStock < enterAmount ) {
            return toast.error("ຈໍານວນຂາຍຕ້ອງບໍ່ເກີນໃນສະຕ໋ອກ");
        }
        if (enterAmount <= 0) {
            return toast.error("ຕ້ອງຕ້ອງຈໍານວນຕ້ອງການຂາຍຫຼາຍກວ່າຫນຶ່ງຊິ້ນ!");
        }
        const amount = enterAmount - amountSale;
        if (amount <= 0) {
            _stockOption[index] = {
                ..._stockOption[index],
                amountAll, amount: amountOld
            };
            setStockOptionItems(_stockOption);
            return toast.error("ຈຳນວນບໍ່ຖືກຕ້ອງ ກະລຸນາເລືອກໃຫມ່! amount: " + amount);
        } else {
            _stockOption[index] = {
                ..._stockOption[index],
                amount,
                amountAll: enterAmount,
            };
            setStockOptionItems(_stockOption);
        }
    };

    const changeVolumeOnCart = (index, e) => {
        let _stockOption = [...stockOptionItems];
        // const validate = parseInt(_stockOption[index].validateAmount) || 0;
        const volumeStock = parseInt(_stockOption[index].stock.volume) || 0;
        const enterVolume = parseInt(e.target.value) || 0;
        const volumeSale = parseInt(_stockOption[index].volumeSale) || 0;
        const volumeAll = parseInt(_stockOption[index].volumeAll) || 0;
        const volumeOld = parseInt(_stockOption[index].volume) || 0;

        // if ( (validate + amountStock) < enterAmount ) {
        // if (volumeStock < enterVolume ) {
        //     return toast.error("ຈໍານວນຂາຍຕ້ອງບໍ່ເກີນໃນສະຕ໋ອກ");
        // }
        // if (enterVolume <= 0) {
        //     return toast.error("ຕ້ອງຕ້ອງຈໍານວນຕ້ອງການຂາຍຫຼາຍກວ່າຫນຶ່ງຊິ້ນ!");
        // }
        const volume = enterVolume - volumeSale;
        if (volume <= 0) {
            _stockOption[index] = {
                ..._stockOption[index],
                volumeAll, volume: volumeOld
            };
            setStockOptionItems(_stockOption);
            return toast.error("ຈຳນວນບໍ່ຖືກຕ້ອງ ກະລຸນາເລືອກໃຫມ່! volume: " + volume);
        } else {
            _stockOption[index] = {
                ..._stockOption[index],
                volume,
                volumeAll: enterVolume,
            };
            setStockOptionItems(_stockOption);
        }
    };

    const changeStatusOnCart = (index, e) => {
        let _stockOption = [...stockOptionItems];
        _stockOption[index] = {
            ..._stockOption[index],
            status: e.target.checked,
        };
        setStockOptionItems(_stockOption);
    };
    
    const changePriceOnCart = (stock, index, e) => {
        let _stockOptionItems = [...stockOptionItems];

        _stockOptionItems[index] = {
            ..._stockOptionItems[index],
            price: parseInt(e.target.value) || 0,
        };
        setStockOptionItems(_stockOptionItems);
    };

    const checkSameCode = (index) => arrSameCode.filter((item) => item == index);

    const onSelectedAllStocks = async () => {
        if (isSelectAll) {
        setDataFromSelect([]);
        setIsSelectAll(false);
        } else {
        let _stockList = [];
        for (var i = 0; i < stockList.length; i++) {
            let postStockIndex = stockOptionItems.findIndex((pStock => pStock?.stock?.id === stockList[i]?.id));
            if (postStockIndex < 0)
            _stockList.push({
                stock: stockList[i],
                price: stockList[i]?.price ?? 0,
                originPrice: stockList[i]?.originPrice ?? 0,
                amount: stockList[i].amount ?? 0,
                amountAll: stockList[i].amount ?? 0,
                validateAmount: 0,
                volume: stockList[i].volume ?? 0,
                volumeAll: stockList[i].volumeAll ?? 0,
                validateVolume: 0,
                name: stockList[i]?.name ?? "",
                currency: stockList[i]?.currency,
            });
        }
        setDataFromSelect(_stockList);
        setIsSelectAll(true);
        }
    };

    const onRemoveAllStocks = async () => {
        // console.log("stockList: ", stockList)
        if (isRemoveAll) {
        setDataFromSelect([]);
        setIsRemoveAll(false);
        } else {

        setIsRemoveAll(true);
        }
    };

    const onRemoveAllStocksItemsFromCart = async () => {
        setStockOptionItems([]);
        setIsRemoveAll(false);
    };

    // change page limit
    const handlePerPageChange = (limit) => {
        setPerPageLimit(limit); // Update the perPageLimit state
        setPage(0); // Reset page to 0 when perPageLimit changes
    };

    if (userStockLoading && loadingStockOptionItems) return <LoadingSpinner />

    return (
        <>   
            {/* // Stock option item  */}
            <div>
                <div>
                    <div style={{ background: "#F1F1F1", fontSize: 13 }}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            justifyItems: "center",
                            background: "#fff",
                            borderRadius: "6px",
                            margin: "0px 10px 0px 10px",
                            padding: "20px 10px 20px 10px",
                            whiteSpace: 'nowrap'
                        }}>
                            <div className="row">
                                <div
                                    style={{
                                        background: "#F9F9F9",
                                        width: "70px",
                                        height: "46px",
                                        borderRadius: "6px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyItems: "center",
                                        verticalAlign: "centered",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: 'nowrap',
                                        maxLines: 2,
                                        marginLeft: 5,
                                        // paddingLeft: 5
                                    }}
                                >
                                    <Form.Check
                                        type="checkbox"
                                        disabled={clickMode === 'add'}
                                        label={isStatus ? "ເປີດ" : "ປີດ"}
                                        value={isStatus}
                                        checked={isStatus}
                                        onChange={(e) => setIsStatus(e?.target?.checked)}
                                    />
                                </div>
                                
                                <div className="col-3" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>ຫົວຂໍ້: </div>
                                    <div
                                        style={{
                                        background: "#F9F9F9",
                                        width: "250px",
                                        height: "46px",
                                        borderRadius: "6px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyItems: "center",
                                        verticalAlign: "centered",
                                        marginLeft: 5,
                                        paddingLeft: 5,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: 'nowrap',
                                        maxLines: 2,
                                        }}
                                    >
                                        <Form.Control type="text" onChange={e => setName(e?.target?.value)} value={name}/>
                                    </div>
                                </div>
                                <div className="col-3" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>ແທັກການໃຊ້ງານ:</div>
                                    <div
                                        style={{
                                            background: "#F9F9F9",
                                            width: "200px",
                                            height: "46px",
                                            borderRadius: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyItems: "center",
                                            verticalAlign: "centered",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: 'nowrap',
                                            maxLines: 2,
                                            // marginLeft: 5,
                                            paddingLeft: 5,
                                            // marginRight: 10
                                        }}
                                    >
                                        <Form.Select
                                            style={{
                                                height: "40px",
                                                color: "#6B7280",
                                                cursor: "pointer",
                                            }}
                                            onChange={(e => setTag(e?.target?.value))}
                                            value={tag}
                                        >
                                            <option value="">ເລືອກແທັກ</option>
                                            {STOCK_OPTION_TAG_KEYS?.map((i, index) => (
                                                <option key={1 + index} value={i?.value}>
                                                    {i?.key}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                </div>
                                <div className="col-3" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>ຮູບອບບການຂາຍ:</div>
                                    <div
                                        style={{
                                            background: "#F9F9F9",
                                            width: "200px",
                                            height: "46px",
                                            borderRadius: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyItems: "center",
                                            verticalAlign: "centered",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: 'nowrap',
                                            maxLines: 2,
                                            // marginLeft: 5,
                                            paddingLeft: 5,
                                            // marginRight: 10
                                        }}
                                    >
                                        <Form.Select
                                            style={{
                                                height: "40px",
                                                color: "#6B7280",
                                                cursor: "pointer",
                                            }}
                                            onChange={(e => setSaleTag(e?.target?.value))}
                                            value={saleTag}
                                        >
                                            <option value="">ເລືອກຮູບແບບ</option>
                                            {STOCK_OPTION_ITEM_SALE_TAG_KEYS?.map((i, index) => (
                                                <option key={1 + index} value={i?.value}>
                                                    {i?.key}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                </div>
                                <div className="col-2" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ background: "#F9F9F9",
                                            width: "250px",
                                            height: "46px",
                                            borderRadius: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyItems: "center",
                                            verticalAlign: "centered",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: 'nowrap',
                                            maxLines: 2,
                                            paddingLeft: 5}}>
                                        <Button style={{ marginLeft: 10, marginRight: 10, paddingLeft: "10px" }} variant="light" 
                                            disabled={loadingCreateStockOption || loadingUpdateStockOption} 
                                            onClick={() => {
                                                setClickMode('view'); 
                                                setCancel(true);
                                            }} >
                                            ຍົກເລີກ
                                        </Button>
                                        <Button
                                            onClick={clickMode === 'edit' ? handleUpdateStockOption : handleCreate}
                                            style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, border: 'none' }} 
                                            disabled={loadingCreateStockOption || loadingUpdateStockOption}
                                        >
                                            {(loadingCreateStockOption || loadingUpdateStockOption) ? <><Spinner size="sm" /> Loading...</> : <span>
                                                <ReactIcons.FaCheck />  {clickMode === 'edit' ? "ແກ້ໄຂ" : "ສ້າງໃຫມ່"}
                                            </span>}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                            
                        <div className="product-container">
                            <div className="product_wrapper">
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <p style={{marginTop: 10}}>ທັງຫມົດ ({stockTotal || "0"}), ຫນ້າ{page+1}:({stockList.length ?? 0})</p>
                                    {/* <div className="control-wrapper"> */}
                                        <Button
                                            variant="outline-light"
                                            style={{ background: "#F7F7F7", border: "none", color: "#422F90", fontSize: 13, height: 30 }}
                                            disabled={!isSelectAll}
                                            className="add-product-btn"
                                            onClick={() => onAddAllStockOptionItems()}
                                        >
                                            <FontAwesomeIcon icon={faPlus}  />
                                            ເພີ່ມສິນຄ້າ
                                        </Button>
                                    {/* </div> */}
                                    <div className="d-flex justify-content-center align-items-start gap-1">
                                        <Dropdown>
                                            <Dropdown.Toggle variant="light" id="dropdown-basic" style={{ fontSize: 13 }}>
                                            ສະແດງ {perPageLimit}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => handlePerPageChange(150)}>150/ໜ້າ</Dropdown.Item>
                                            <Dropdown.Item onClick={() => handlePerPageChange(800)}>800/ໜ້າ</Dropdown.Item>
                                            <Dropdown.Item onClick={() => handlePerPageChange(1000)}>1000/ໜ້າ</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <PaginationsV2
                                            count={stockTotal}
                                            perPageLimit={perPageLimit}
                                            page={page}
                                            pageAll={pageAll}
                                            onPageChange={handleChangePage}
                                            textNext=">"
                                            textPrev="<"
                                        />
                                    </div>           
                                </div>
                                {(userStockLoading && !userStockData) ? <LoadingSpinner /> :
                                <div>
                                    <Table
                                        style={{
                                            marginTop: "20px",
                                            borderCollapse: "collapse",
                                            width: "100% ",
                                            fontSize: 13,
                                        }}
                                    >
                                    <tbody>
                                        <tr>
                                        <th style={{ width: "1%" }}>
                                            <input id="btn-disable" type="checkbox" checked={isSelectAll} onClick={() => onSelectedAllStocks()} />
                                        </th>
                                        <th style={{ width: "5%", textAlign: "center", fontSize: 13 }}>ຮູບ</th>
                                        <th style={{ verticalAlign: "middle", fontSize: 13 }}>ຊື່ສິນຄ້າ</th>
                                        <th style={{ verticalAlign: "middle", fontSize: 13 }}>ລາຄາ</th>
                                        <th style={{ verticalAlign: "middle", fontSize: 13 }}>ຈ/ນ</th>
                                        <th style={{ verticalAlign: "middle", fontSize: 13 }}>ບໍລິມາດ</th>
                                        <th style={{ verticalAlign: "middle", fontSize: 13 }}>ຈັດການ</th>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        {stockList.length > 0 &&
                                        stockList?.map((stock, index) => (
                                            <tr key={stock + index}>
                                            <td >
                                                {checkStockIsAdded(stock) ? (
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked
                                                        disabled
                                                    />
                                                    ) : (
                                                    <Form.Check
                                                        type="checkbox"
                                                        disabled
                                                        checked={isSelectAll}
                                                    />
                                                )}

                                            </td>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                <img
                                                src={imageRender(stock?.image)}
                                                alt=""
                                                style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    background: "gold",
                                                }}
                                                />
                                            </td>
                                            <td style={{ verticalAlign: "middle", fontSize: 13 }}> {stock?.name ?? '-'}</td>
                                            <td style={{ verticalAlign: "middle", fontSize: 13 }}>
                                                {stock?.price ?? 0}
                                                {stock?.currency ??convertCurrency(stock?.currency)}
                                            </td>
                                            <td style={{ verticalAlign: "middle", fontSize: 13 }}> {stock?.amount}/{stock?.amountAll ?? 0} {stock?.unit}</td>
                                            <td style={{ verticalAlign: "middle", fontSize: 13 }}> {stock?.volume ?? 0}/{stock?.volumeAll ?? 0}{stock?.unit}</td>
                                            <td style={{ verticalAlign: "middle", fontSize: 13 }}>
                                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%" }}>
                                                {checkStockIsAdded(stock) ?
                                                    <a className="btn"
                                                    style={{ color: "#616161" }}>ເພີ່ມແລ້ວ</a> :
                                                    stock?.amount != 0 ? <a className="btn hoverme"
                                                    disabled={isSelectAll}
                                                    onClick={() => {
                                                        if (isSelectAll) return;
                                                        addStockOptionItem(stock);
                                                    }}
                                                    style={{
                                                        borderColor: !isSelectAll ? COLOR_APP : "grey",
                                                        color: !isSelectAll ? COLOR_APP : "grey",
                                                        cursor: !isSelectAll ? "pointer" : "no-drop",
                                                    }}>
                                                    <FontAwesomeIcon icon={faPlus} style={{ color: !isSelectAll ? COLOR_APP : "grey", fontSize: 13 }} /> ເພີ່ມ</a> : <div />}
                                                </div>
                                            </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    </Table>
                                </div>
                                }

                            </div>
                            <div className="product_wrapper">
                                <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                <p style={{ padding: "4px 12px", fontWeight: "bold" }}>ສິນຄ້າໃນໂພສ({stockOptionItems?.length || 0})</p>

                                <Button
                                    disabled={!isRemoveAll || loadingUpdateManyStockOptionItems || clickMode === "add"}
                                    style={{
                                        color: COLOR_WHITE,
                                        fontSize: 13,
                                        padding: "4px 12px",
                                        borderRadius: "6px",
                                        background: LINEAR_GRADIENT_BG,
                                        border: "none", cursor: "pointer"
                                    }}
                                    onClick={() => handleUpdateManyStockOptionItems()}
                                >
                                    {loadingUpdateManyStockOptionItems ? <><Spinner size="sm" /> updating...</> : <span>
                                        <ReactIcons.FaCheck /> {clickMode === "edit" ? "ແກ້ໄຂສີນຄ້າ" : "ບັນທືກສີນຄ້າ"}
                                    </span>}
                                </Button>
                                <Button
                                    disabled={!isRemoveAll}
                                    style={{
                                    color: "#D21C1C",
                                    fontSize: 13,
                                    padding: "4px 12px",
                                    borderRadius: "6px",
                                    background: "#F7F7F7",
                                    border: "none"
                                    }}
                                    onClick={() => onRemoveAllStocksItemsFromCart()}
                                >
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: 5 }} />
                                    ນຳອອກ
                                </Button>
                                </div>
                                <div>
                                {
                                    stockOptionItems?.length == 0 ? (
                                    <>
                                        <div className="no_product">
                                            <img src={no_product} alt="" />
                                            <h1>ເພີ່ມສິນຄ້າເຂົ້າໃນໂພສ</h1>
                                        </div>
                                    </>) : (<>
                                    <Table 
                                        style={{
                                            marginTop: "25px",
                                            borderCollapse: "collapse",
                                            width: "100% ",
                                            fontSize: 13,
                                        }}
                                    >
                                        <tbody>
                                        <tr>
                                            <th style={{ width: "1%" }}>
                                            <input id="btn-disable" type="checkbox" checked={isRemoveAll} onClick={() => onRemoveAllStocks()} />
                                            </th>
                                            {/* <th style={{ width: "5%", textAlign: "center" }}>ຮູບ</th> */}
                                            <th style={{ verticalAlign: "middle", fontSize: 13 }}>ຊື່ສິນຄ້າ</th>
                                            <th style={{ verticalAlign: "middle", fontSize: 13 }}>ລາຄາ</th>
                                            <th style={{ verticalAlign: "middle", fontSize: 13 }}>ຈ/ນ</th>
                                            <th style={{ verticalAlign: "middle", fontSize: 13 }}>ຈ/ນ(all)</th>
                                            <th style={{ verticalAlign: "middle", fontSize: 13 }}>ບໍລິມາດ</th>
                                            <th style={{ verticalAlign: "middle", fontSize: 13 }}>ບໍລິມາດ(all)</th>
                                            <th style={{ verticalAlign: "middle", fontSize: 13 }}>ຈັດການ</th>
                                        </tr>
                                        </tbody>
                                        <tbody>
                                        {stockOptionItems?.length > 0 &&
                                            stockOptionItems?.map((lStock, index) => (
                                            <tr key={lStock + index} style={{ cursor: "pointer",
                                                background: lStock?.status ? "white": "red" }}>
                                                <td>
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={isRemoveAll}
                                                    />
                                                </td>
                                                <td>
                                                    <pre
                                                        style={{
                                                        fontSize: 13,
                                                        margin: 0,
                                                        }}
                                                    >
                                                        {lStock?.stock?.name ?? "-"}
                                                    </pre>
                                                </td>
                                                
                                                <td>
                                                    <Form.Control
                                                        type="text"
                                                        onChange={(e) => {
                                                        changePriceOnCart(lStock, index, e);
                                                        }}
                                                        value={stockOptionItems[index]?.price+convertCurrency(stockOptionItems[index]?.currency)}
                                                        style={{ color: "red", fontSize: 13 }}
                                                        placeholder="ລາຄາ..."
                                                    />
                                                    {checkSameCode(index).length > 0 && (
                                                        <span style={{ color: "red", fontSize: 13 }}>
                                                        ສີນຄ້າຕ້ອງບໍ່ຊໍ້າກັນ​!
                                                        </span>
                                                    )}
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        // onChange={(e) => {
                                                        //     changeAmountOnCart(lStock, index, e);
                                                        // }}
                                                        disabled
                                                        value={stockOptionItems[index].amount}
                                                        style={{ fontSize: 13, width: 40 }}
                                                        placeholder="ຈໍານວນ..."
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        onChange={(e) => {
                                                            changeAmountOnCart(lStock, index, e);
                                                        }}
                                                        value={stockOptionItems[index].amountAll}
                                                        style={{ fontSize: 13, width: 40 }}
                                                        placeholder="ຈໍານວນ..."
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        disabled
                                                        // onChange={(e) => {
                                                        //     changeVolumeOnCart(index, e);
                                                        // }}
                                                        value={stockOptionItems[index]?.volume}
                                                        style={{ fontSize: 13, width: 40 }}
                                                        placeholder="ບໍລິມາດ..."
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        onChange={(e) => {
                                                            changeVolumeOnCart(index, e);
                                                        }}
                                                        value={stockOptionItems[index]?.volumeAll}
                                                        style={{ fontSize: 13, width: 40 }}
                                                        placeholder="ບໍລິມາດ..."
                                                    />
                                                </td>
                                                <td>
                                                    <div style={{ display: "flex" }}>
                                                        <span><Form.Check
                                                            type="checkbox"
                                                            checked={stockOptionItems[index]?.status}
                                                            onChange={(e) => {
                                                                changeStatusOnCart(index, e);
                                                            }}
                                                            style={{ fontSize: 13 }}
                                                        /></span>
                                                        <Button
                                                            disabled={lStock?.amountSale > 0 || lStock?.volumeSale > 0}
                                                            className="btn btn-danger"
                                                            onClick={() => removeStockFromCart(lStock)}
                                                            style={{
                                                                color: "#fff", fontSize: 13
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    </>)
                                }
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                </div >
        </>
    );
};

export default FormStockOption;